// Zentrale Umgebungskonfiguration
// Diese Datei verwaltet die API-Basis-URL für alle Environments

export interface Environment {
  API_BASE_URL: string;
  DEBUG: boolean;
  NODE_ENV: string;
}

// API-Basis-URL - HIER KONFIGURIEREN
const API_BASE_URL = 'https://buchungsmanager.ddev.site';

// Umgebungskonfiguration
export const environment: Environment = {
  API_BASE_URL,
  DEBUG: true, // Kann auf false gesetzt werden für Produktion
  NODE_ENV: process.env.NODE_ENV || 'development'
};

// Helper-Funktion um die API-Basis-URL zu bekommen
export const getApiBaseUrl = (): string => {
  return environment.API_BASE_URL;
};

// Helper-Funktion um vollständige API-URLs zu erstellen
export const buildApiUrl = (endpoint: string): string => {
  const baseUrl = getApiBaseUrl();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

// Debug-Ausgabe im Development-Modus
if (environment.DEBUG && typeof window !== 'undefined') {
  console.group('🔧 API Konfiguration geladen');
  console.log('API Base URL:', environment.API_BASE_URL);
  console.log('Debug Mode:', environment.DEBUG);
  console.log('Node Environment:', environment.NODE_ENV);
  console.log('Beispiel REST API:', buildApiUrl('/rest/api'));
  console.groupEnd();
}

export default environment; 